/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cli_auth_permissions_alias_read = /** @type {(inputs: {}) => string} */ () => {
	return `Leer alias`
};

const en_cli_auth_permissions_alias_read = /** @type {(inputs: {}) => string} */ () => {
	return `Read aliases`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cli_auth_permissions_alias_read = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cli_auth_permissions_alias_read(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cli_auth_permissions_alias_read", locale)
	if (locale === "es") return es_cli_auth_permissions_alias_read(inputs)
	return en_cli_auth_permissions_alias_read(inputs)
};
export { cli_auth_permissions_alias_read as "cli_auth.permissions.alias_read" }